import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { ChecklistFormControlComponent } from './checklist-form-control.component';

import { MatIconModule } from '@angular/material/icon';
import { FormControlsUtilsModule } from '../form-controls-utils';



@NgModule({
  declarations: [
    ChecklistFormControlComponent
  ],
  exports: [
    ChecklistFormControlComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    MatCheckboxModule,
    MatSelectModule,
    MatFormFieldModule,
    FormControlsUtilsModule,
    MatChipsModule,
    MatIconModule
  ]
})
export class ChecklistFormControlModule { }
